import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth37: ToothDataEntry = {
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M40.1,182.8l-4.7-18.3-24.6-56.8-3.8-14.6-1.3-9.4.4-9.7.9-6.9,2.4-6.6,1.3-2.8,2.8-1.8,4.5-.9h5s3.5.4,3.5.4l18-10.4,17.2-6,19.9,2.1,44.2-3.4,22.7,8.2,4.5,2.4,3.5.5,9.1,3.2,16.2-2.9,7.1,2.4,4.8,6.6,1.9,6.8,1.3,5.7,2,14.7.9,13.9-.2,11.1-.8,15.1-2.2,17.1-3.4,14-1.9,6.6-2.4,7.6c-79.6,40.5-148.9,12.1-148.9,12.1Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M131.3,140.9a17.9,17.9 0 1,1 -35.8,0a17.9,17.9 0 1,1 35.8,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.7,174.9s22.1-2.1,28.6-3,10.9-5.7,9.9-13.4c-1.2-8.9-15.8-118.9-15.8-118.9l-19.7,6.4-15.2,9.7-6.7-.3-5.7,1.4-3.1,1.5-3,4.3-1.2,6.3-.8,6.6.4,8.8,2.2,15.4,4.8,14.6,25.4,60.5Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M140.7,43.4l21.1,9.3,7.6-1,11.5-2.5,9.2,4.1,4.4,7.5,3.1,13.9,1,19.1.8,20.1-1.5,19.2-1.6,9.3-4.1,18-23.6,2.1c-6.5.9-11.9-2.8-12.8-9.4-6.5-26.6-15.2-109.5-15.2-109.5h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M40.1,182.8l-1.6-11.3-3.8-13.9-26.1-57.9-2.2-15.4-.4-8.8.8-6.6,1.2-6.3,3-4.3,3.2-1.6h0s5.7-1.4,5.7-1.4l6.7.3,10.4-5.6,8.4-3.9,9.3-4.4,7.4-2.3,20.6,2.2c-4.4,34.2,40.2,122.7,25.6,150.3-40.5,2.3-68.1-9.3-68.1-9.3Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M108.2,192.1c13.4-33.5-30.8-116.3-25.6-150.4l27.9-2.6,17.3-1.2h0s34,14.7,34,14.7l7.6-1,11.5-2.5,9.2,4.1,4.4,7.5,3.1,13.9,1,19.1.8,20.1-1.5,19.2-1.6,9.3-4.1,18-3.3,10.5c-41.4,21.3-80.8,21.4-80.8,21.4Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M40.1,182.8s68.6,28,148.9-12.1l-2.3,14.4s-52.3,38.7-144.2,13.1l-2.5-15.4Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'14.9 112.7 41.8 135.9 41.5 91.7 67.1 141 73.7 87.3 98.4 139.4 107.1 86 131.3 134.8 139.4 80.9 163 130.4 168.5 78.3 183.7 118.4 198.8 86.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'153 181.3 142.2 190.8 157.9 196.3 147 205.8 161.5 210.9 151.2 220.1 164.2 224.6 154.2 233.5 169.1 238.7 159.3 247.2 171.2 251.4 161.4 260 174.5 264.5 164.1 273.7 176.3 277.9 165.9 287.1 177.4 291.2 167.3 300 181.2 304.9 169.3 315.3 182.7 320.1 170.9 330.3 184.9 335.2 173.3 345.3 189 350.8 178.4 360.2 193.1 365.4 180.4 376.4 194.3 381.3 182.9 391.3 197.6 396.4 185.6 407 200.1 412.1 188.4 425.5',
				'130.4 429.1 125.7 417.3 112.6 419.1 114.4 407.3 98.7 405.6 107.6 393.9 89.2 389.4 101.3 380.9 86.1 373.8 98.8 364.8 86.1 358.7 99.7 349.1 85.8 342.5 97.9 334.1 83.8 327.4 95.4 319.1 81.1 312.3 93.2 303.9 81 298.1 91 291 78.5 285 89.1 277.7 76.6 271.7 88 263.8 76.1 258.1 86.5 250.9 74.7 245.3 87.7 236.3 75.6 230.5 86.9 222.6 74.5 216.6 87.1 207.7 74 201.5 87.6 191.9 74.6 185.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'55.4 313.4 73.8 328.4 86.9 308.7 108 325.4 124.2 303.5 142.6 321.4 157.5 302.3 173.9 314.6 183.8 297.4 197.6 313 205.4 295.3',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '29.8 161.9 16.7 147.6 11.5 130.5 6.2 95.5 6.1 82.7 9.3 66 18.5 53.5 33.9 44 49.1 38.3 66.7 35.9 98.8 22.4 122.6 18.1 157.2 23.5 174.2 35.2 182.7 49.5 193.8 100.8 193 112.3 187.4 147.8 177.4 162.8 163.3 171.9 149.2 179.3 139.4 182.9 111.9 187.7 93.5 188.5 69.9 184 29.8 161.9',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M47.6,84.4l18.8,6.4s16.4,5.6,3.1,19-12.4,12.4-12.4,12.4l-33.9,31.8-6.8-6-4.3-14.7-5.1-29.6-.6-12.3-.6-10.3,2.2-10,39.5,13.3Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M177,41.9l-24.1,28.6-8.6,10s-11.2,9,.8,18.7l10.6,11.5,30.9,33.3c8.1-8.3,6.4-43.7,6.4-43.7l-6.4-37.3-3.8-11.3-3.3-6.9s-2.5-3-2.5-3Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M155.6,110.7s-24.3-6.6-28.2-3.8-4.5,5-5.5,21.8c-1,16.7,15.9,54.5,15.9,54.5l14.3-5.1,7.7-3.7,7.9-5.3,4.8-4.1,5-2.1,9.4-13.3-.4-5.6-30.9-33.3Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23.2,154l33.9-31.8s22.7-9.9,42.4,1.9c19.8,11.8,21.5-14.6,27.8-17.1.2,0-4.6,2.2-5.3,21.8,0,17.7,9.5,39.9,15.9,54.5l-26.1,4.3-19.3.3-22.7-4-31.3-16.7-8.8-5.5-6.5-7.9Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M8.2,71l3.4-7.5,7.2-10,14.5-8.9,15.9-6.2,18.5-2.8,17.1-6.3s7.2,14.1,9.2,22c-1.3,9.1,8.2,20.4,8.2,20.4-20.9,2.2-20.7,23.3-54.4,12.9l-39.5-13.3h0Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M84.8,29.2l14-6.8,23.8-4.3,7.5,1.6,9.8.9,9,1.8,8.2,1,5.7,4.6,5.2,2.9,6.1,4.2,2.8,6.7-24.1,28.6s-11.7,4.9-15.8,6.1-8.1,1.9-14.9-2.2-20.2-2.9-20.2-2.9c-6.8-8.8-9-14.7-8.2-20.4,0,0-1.6-6.1-9.1-22.1h0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M55.9,86.5c24.4,4.7,29.4-14.1,46.2-14.9,5.5-.3,14.3-.5,20.2,2.9s9.3,4,14.9,2.2l15.8-6.1c.4,3.9-22.5,16.1-7.9,28.8l10.6,11.5s-21.9-6.1-28.2-3.8c-1.7,0-6.7,11.6-9.5,15.2-7.5,9.4-16.4,3.1-18.3,1.9-23.4-10.7-42.4-1.9-42.4-1.9,0,0,9.3-9.5,12.4-12.6,11.1-11.8,2.1-16.7-8.7-20.6-6.9-2.5-13.3-4.6-13.3-4.6l8.2,2.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'9.4 113.2 36.9 133.5 34.2 91.8 61.5 136.8 65.2 85.6 91.7 133.4 97.3 82.3 123.3 127 128.1 75.4 153.8 120.9 156.3 71.1 173.3 107.9 185.8 76.5',
			],
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M180.4,349.5l2.2,6.4,4.2,21,1.4,20.1-.9,15.1-1.2,13.4-2.7,9.5-5.1,12.9-8.9,12.3-10.9,9-17,3.8-16-3.6-33.5-6.5-18.3,4.7-16.3.2-22.3-2.3-11.3-5.5-7.6-7.6-4.3-9.2-2.9-16.6,1.2-11,2.8-13.4,5.3-15.5,20.3-49.6s37.4-17.5,141.8,12.5Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M123.4,369.8a18.3,18.3 0 1,1 -36.6,0a18.3,18.3 0 1,1 36.6,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.1,352.2s-23.9,56.4-23.5,63.2c.4,6.4-9.5,44,31.9,50.6,9.9,1.6,13.5.9,13.5.9l13.3-95.7s4-13.1-7.2-15.7c-11.2-2.6-28-3.3-28-3.3Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M184.9,368s14.1,76.5-24.2,99.5c-5.2,4.9-19.5,4-19.5,4l-13.2-1.8,12.8-92.3s.5-12.4,11.6-11.4c11.1.9,32.5,2.1,32.5,2.1h0Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M183.4,356.2s26.1,74.1-22,111c-6.4,4.9-19.1,4.5-19.1,4.5l-48.1-8.7s-6.2-30.7,14.8-41.9c15.4-8.3,6.8-85.9,6.8-85.9,28.5,3.5,65.7,14.5,65.7,14.5l2,6.6Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M37.2,340s-27.1,68.6-26.6,75.3c.4,6.4-9.3,42.9,31.9,50.6,23.9,4.6,51.5-3.1,51.5-3.1,0,0-6.3-30.5,14.8-41.9,15.2-7.4,6.8-85.9,6.8-85.9-57.3-7.4-77.1,2-77.1,2l-1.4,3Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.6,337s39.1-17.1,141.8,12.5l-2.7-13s-73.6-21.3-134.6-14.9l-2,7.1-2.5,8.3Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'16.4 403.2 41.1 382.7 40.7 421.8 63.8 378.4 69.9 426 92.4 380.1 100.1 427.4 122 384.3 129.2 432.1 150.8 388.4 155.9 434.7 169.7 399.2 183 428',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'191.5 79.3 201.8 96.4 186.1 98 197.8 111.6 183.1 116.7 195.3 127.5 180.4 132.6 191.9 142.8 177.8 147.7 190.6 158.8 175.7 164 186.4 173.5 170.5 179.1 182.2 189.3 168.1 194.2 179.9 204.6 166.3 209.4 178.3 220 164.2 224.8 174.5 233.8 162.8 237.9 173.3 247.3 160.9 251.4 171.4 260.8 158.1 265.3 168.1 274.1 156 278.2 165.9 286.9 150.8 292.1 160.9 301.1 147.7 305.6 158.1 314.9 143.4 320 154.4 329.8 138.5 335.2 149.4 344.9',
				'70.1 340.1 83.3 333.9 69.6 324.2 82.8 317.9 70.1 308.9 82.7 302.9 71.3 294.9 83.5 289.1 70.4 279.8 82.4 274.2 71.9 266.9 83.9 261.2 72.4 253.2 85.1 247.2 74.4 239.7 87 233.7 76.9 226.5 89.3 220.7 77.1 212.1 91.6 205.3 79.9 196.9 94.2 190.2 82 181.6 96.1 175 82.4 165.2 95.2 159.1 82.4 150 97.8 142.8 85.6 134.2 99.5 127.6 87.9 114.7 101.2 111.6 96.3 97.6 112.8 97.7 109.5 85.3 127 75.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'198.6 233.4 190.9 215.5 176.8 231.2 166.9 213.8 150.3 226.2 135.2 206.8 116.5 224.8 100.2 202.7 78.8 219.5 65.8 199.5 47 214.6',
			],
		},
	},
};
